import { render, staticRenderFns } from "./WorkflowComponent.vue?vue&type=template&id=5ab0bcb0&scoped=true&"
import script from "./WorkflowComponent.vue?vue&type=script&lang=ts&"
export * from "./WorkflowComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowComponent.vue?vue&type=style&index=0&id=5ab0bcb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab0bcb0",
  null
  
)

export default component.exports